import { render, staticRenderFns } from "./PedidosValidarSingle.vue?vue&type=template&id=56b76900&scoped=true&lang=pug"
import script from "./PedidosValidarSingle.vue?vue&type=script&lang=js"
export * from "./PedidosValidarSingle.vue?vue&type=script&lang=js"
import style0 from "./PedidosValidarSingle.vue?vue&type=style&index=0&id=56b76900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b76900",
  null
  
)

export default component.exports